var _g, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotcosLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "100 220 340 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-261.29037,-11.039509)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A9003D",
    d: "M 417.2,294.5 H 373 c -0.7,19.4 7.2,27.5 21.9,27.5 6.9,0 14.2,-1.7 19.2,-4.2 l 0.9,8.3 c -6.1,2.5 -13.6,3.9 -21.8,3.9 -19.9,0 -30.6,-10.6 -30.6,-33.2 0,-19.4 10.6,-33.9 29,-33.9 18.2,0 25.8,12.4 25.8,26.7 0.1,1.2 0.1,2.9 -0.2,4.9 z m -26,-24.2 c -9.3,0 -16,6.6 -17.6,16.8 h 33.5 c 0.3,-10 -5.8,-16.8 -15.9,-16.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9003D",
    d: "m 440.4,328.9 h -9.8 v -88.6 c -3.2,-0.5 -7.7,-1 -11.6,-1.3 v -5.6 c 5.8,-0.8 14.6,-1.2 21.4,-0.9 v 96.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9003D",
    d: "M 544.6,328.9 V 287 c 0,-9.8 -2.3,-16.2 -11.8,-16.2 -10.2,0 -19.8,10.3 -19.8,27.1 v 30.9 h -10 v -42 c 0,-8.9 -1.7,-16 -11.8,-16 -11,0 -19.9,11.2 -19.9,27.1 v 30.9 h -9.8 v -57 c -3.2,-0.5 -7.7,-1 -11.6,-1.3 V 265 c 5.9,-0.8 14.6,-1.2 21.4,-0.9 0,4.2 -0.4,10.3 -1.1,14.3 l 0.1,0.1 c 3.9,-9.5 12.5,-15.8 23.4,-15.8 14.9,0 18.1,10.6 18.4,15.5 2.5,-6.1 9.7,-15.5 23,-15.5 12.5,0 19.5,6.5 19.5,21.1 v 45 h -10 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9003D",
    d: "m 592.9,330.1 c -17.7,0 -29.1,-10.6 -29.1,-33.2 0,-18.5 11.7,-33.9 31.5,-33.9 16.1,0 29.3,8.7 29.3,32.5 -0.1,19.2 -12.2,34.6 -31.7,34.6 z m 1.4,-59.1 c -10.4,0 -20.2,7.7 -20.2,25 0,16.6 7.3,25.7 20.2,25.7 10.4,0 19.8,-7.8 19.8,-25.7 0.1,-15.6 -6.6,-25 -19.8,-25 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9003D",
    d: "m 645.3,330.1 c -4.9,0 -10,-0.5 -14,-1.3 l 0.3,-9 c 4.3,1.2 9.6,2.1 14.8,2.1 9.6,0 16.2,-4.2 16.2,-11 0,-15.5 -32.2,-5.9 -32.2,-28.9 0,-10.8 9,-19 25.8,-19 4.1,0 8.8,0.7 12.9,1.4 l -0.3,8.5 c -4.4,-1.4 -9.2,-2.2 -13.7,-2.2 -9.7,0 -14.5,3.9 -14.5,10.3 0,15.5 32.3,6.6 32.3,28.7 0.1,11.4 -10.3,20.4 -27.6,20.4 z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 245.46,
    fill: "#A9003D",
    width: 15.6,
    height: 15.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 399.21,
    y: 221.36,
    fill: "#A9003D",
    width: 15.6,
    height: 15.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 423.3,
    y: 221.36,
    fill: "#A9003D",
    width: 15.6,
    height: 15.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotcosLogo);
export default __webpack_public_path__ + "static/media/motcos_logo.44164b85014d993a49f8facc04878adb.svg";
export { ForwardRef as ReactComponent };